import Vue from "vue";
import httpService from "../../components/service";
import cacheService from "@/services/cache";

export const filters = {
    namespaced: true,
    state: {
        filters: {}
    },
    getters: {
        getLength: (state, getters) => seg => {
            return Vue._.size(state.filters[seg]);
        },
        getFilters: (state, getters) => seg => {
            switch (seg) {
                case "systemTypes":
                    return state.filters.systemTypes;
                case "standDesigns":
                    return state.filters.standDesigns;
                case "types":
                    return state.filters.types;
                case "sections":
                    return state.filters.sections;
                case "categories":
                    return state.filters.categories;
                case "status":
                    return state.filters.status;
            }
        },
        getFilterName: (state, getters) => (type, id) => {
            switch (type) {
                case "type":
                    return state.filters.types.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
                case "section":
                    return state.filters.sections.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
                case "category":
                    return state.filters.categories.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
                case "standDesigns":
                    return state.filters.standDesigns.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
                case "systemTypes":
                    return state.filters.systemTypes.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
                case "status":
                    return state.filters.status.find(function(filter) {
                        return filter.id === parseInt(id);
                    }).name;
            }
        }
    },
    mutations: {
        POPULATE_FILTERS(state, data) {
            state.filters.types = data.types;
            state.filters.sections = data.sections;
            state.filters.standDesigns = data.standDesigns;
            state.filters.systemTypes = data.systemTypes;
            state.filters.categories = data.categories;
            state.filters.status = data.status;
        }
    },
    actions: {
        populate: (context, data) => {
            return new Promise((resolve, reject) => {
                let queryString = "?";
                Vue._.forEach(data.routeParams, function(param, key) {
                    if (queryString !== "?") {
                        queryString += "&";
                    }
                    queryString += key + "=" + param;
                });
                httpService.get("/components/filters" + queryString).then(function(datas) {
                    context.commit("POPULATE_FILTERS", datas.data.filters);
                    resolve();
                });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/catalog/filters.js